import { useApolloClient } from '@apollo/react-hooks';
import {
  OutageEventDetails,
  OutageEventParams,
} from '../../../__generated__/pge-types';
import gql from 'not-graphql-tag';
export const getOutageEventDetailsQuery = gql`
  query getOutageEventDetails($params: OutageEventParams!) {
    getOutageEventDetails(params: $params) {
      totalCustomersImpacted
      crewDispatchedStatus
      estimatedTimeOut
      estimatedTimeOn
      cause
      lat
      long
      isStorm
      noOfReports
      eventStatus
    }
  }
`;

const useGetOutageEventDetails = () => {
  const apolloClient = useApolloClient();

  const getOutageEventDetails = async (params: OutageEventParams) => {
    const { data } = await apolloClient.query<{
      getOutageEventDetails: OutageEventDetails;
    }>({
      query: getOutageEventDetailsQuery,
      variables: {
        params,
      },
      fetchPolicy: 'network-only',
    });
    return data?.getOutageEventDetails ? data?.getOutageEventDetails : null;
  };

  return {
    getOutageEventDetails,
  };
};

export default useGetOutageEventDetails;
